import React from "react";
import CustomCheckbox from "../../Components/CustomCheckBox";
import {withButtonLoader} from "../../helpers";

const CreditCardSwipeEntryNmi = ({
                                     addEditSwipeMode,
                                     paymentType,
                                     handleInputChange,
                                     handleSubmit,
                                     isPaymentSaveDetails,
                                     setIsPaymentSaveDetails,
                                     isDefault,
                                     setIsDefault,
                                     transactionLoading,
                                     payerUser,
                                     forceDisableAndCheck = false,
                                 }) => {
    return (
        <div
            className={`tab-pane fade ${(paymentType === "swipe" || addEditSwipeMode === "swipe") ? "show active" : ""}`}
            id="pills-contact"
            role="tabpanel"
            aria-labelledby="pills-contact-tab"
        >
            <div className="sos-content payment-inner-toggleable">
                <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="form-group mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label payment-form-label">
                            Cardholder Name
                        </label>
                        <div className="row g-2">
                            <div className="col-md">
                                <div className="payment-controlpanl-style">
                                    <input
                                        type="text"
                                        name="cardFirstName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder={payerUser?.payerFirst || "First Name"}
                                        defaultValue={payerUser?.payerFirst || ""}
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <div>
                                    <input
                                        type="text"
                                        name="cardLastName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder={payerUser?.payerLast || "Last Name"}
                                        defaultValue={payerUser?.payerLast || ""}
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*                <input*/}
                    {/*                    type="text"*/}
                    {/*                    name="cardLastName"*/}
                    {/*                    className="form-control custom-input-border-css"*/}
                    {/*                    id="exampleInputName3"*/}
                    {/*                    aria-describedby="nameHelp"*/}
                    {/*                    placeholder="Last Name"*/}
                    {/*                    onChange={(e) => handleInputChange(e)}*/}
                    {/*                    value={lastName || ""}*/}
                    {/*                />*/}
                    <div className="checkbox-list mt-3">
                        <label
                            className="label-check font-weight-light float-end">
                            <CustomCheckbox
                                name="isPaymentSaveDetails"
                                disabled={forceDisableAndCheck}
                                checked={forceDisableAndCheck ? true : isPaymentSaveDetails}
                                onChange={(e) => setIsPaymentSaveDetails(!isPaymentSaveDetails)}
                            />
                            Save these payment details for future payments
                        </label>
                        <div className="payment-checbox">
                            <label
                                className="font-weight-light label-check ml-xl-5">
                                <CustomCheckbox
                                    name="isDefault"
                                    checked={isDefault}
                                    onChange={(e) => setIsDefault(!isDefault)}
                                />
                                Set as default payment method
                            </label>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            type="submit"
                            className="sos-mack-btn sos-custom-btn-css"
                            disabled={transactionLoading}
                        >
                            {withButtonLoader("Tap/Insert/Swipe", transactionLoading)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreditCardSwipeEntryNmi;
